export const defaultLang: string = "en_US";
export const langs: string[] = ["en_US", "zh_CN"];

export const timeZone = "UTC";

export const EMAIL_SUFFIX = [
  "gmail.com",
  "outlook.com",
  "yahoo.com",
  "icloud.com",
  "hotmail.com",
];
